"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenToFields = void 0;
const tslib_1 = require("tslib");
/* eslint-disable no-param-reassign */
/**
 * dataSchema相关的转换工具
 */
const field_1 = require("./field");
const cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
const jsonSchema_1 = require("@tencent/data-schema/lib/convertor/jsonSchema");
const DataSchemaContext_1 = require("@tencent/data-schema/lib/core/DataSchemaContext");
// TODO: FIELDCONST.xxx.type去定义
const dataTypeToWuji = {
    array: 0,
    null: 0,
    object: 0,
    any: 0,
    string: 1,
    integer: 8,
    boolean: 9,
    // datetime: 10,
    number: 21,
};
/**
 * 将idl内部fields结构打扁处理成无极字段列表
 * @param fields idl内部fields结构
 * @param {string} prefix keypath前缀，'a.b.c'
 * @param {boolean} displayAll 是否需要全部打扁展示
 */
exports.flattenToFields = (fields, prefix = '', displayAll = false) => {
    const res = [];
    // 不改变原对象
    const copyIdl = cloneDeep_1.default(fields || []);
    copyIdl.forEach((item) => {
        item.id = prefix ? [prefix, item.id].join('.') : item.id;
        if (!Array.isArray(item.fields)) {
            if (item.primary) {
                item.display = true;
            }
            if (displayAll || (!displayAll && item.display)) {
                // 用于下拉框的转换的事情
                item.dataType = item.type;
                item.output = {};
                item.input = {};
                const ui = item.ui || {};
                if (ui.width)
                    item.width = ui.width;
                if (item.primary) {
                    item.type = 101;
                }
                else if (ui.type === 'wujiOmniInput' && ui.settings.type) {
                    // 配置了 ui 字段，自定义渲染
                    item = Object.assign(Object.assign({}, item), (ui.settings || {}));
                    Object.assign(item, ui.settings || {});
                }
                else if (!dataTypeToWuji[item.type]) {
                    // 非 string/boolean/number，使用神秘的真·JSON输入框
                    const schema = item;
                    const defaultValue = new DataSchemaContext_1.DataSchemaContext(schema).makeRootStubOf({})
                        .getDefaultValue({ optionalProperties: 'always' });
                    try {
                        item.args = JSON.stringify({
                            generateForm: true,
                            schema: JSON.stringify(jsonSchema_1.toJSONSchema(item), null, 2),
                        });
                    }
                    catch (e) {
                        // console.log(e);
                        // ignore 可写表达式
                    }
                    item.value = defaultValue;
                    // TODO: FIELDCONST
                    item.type = 26;
                }
                else {
                    // string/boolean/number 使用默认的输入框
                    item.type = dataTypeToWuji[item.type];
                    if (item.enum) {
                        // TODO: FIELDCONST
                        item.type = 5;
                        item.args = `LIST:${JSON.stringify({ options: item.enum.map((x) => ({ value: String(x.value), label: x.label || String(x.value) })) })}`;
                    }
                }
                if ('default' in item)
                    item.value = item.default;
                item.name = item.title || item.id;
                item.desc = item.description || '';
                // 暂时没有把没用到的属性去掉
                res.push(field_1.filterFieldKey(item));
            }
        }
        else {
            res.push(...exports.flattenToFields(item.fields, item.id, displayAll));
        }
    });
    return res;
};
